<template>
  <v-text-field
    :type="type"
    v-bind="$attrs"
    v-on="$listeners"
    :append-icon="icon"
    @click:append="toggle"
    :data-testid="dataTestid"
  />
</template>

<script>
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      type: "password",
    };
  },
  methods: {
    toggle() {
      if (this.type === "password") {
        this.type = "text";
      } else {
        this.type = "password";
      }
    },
  },
  computed: {
    icon() {
      return this.type === "password" ? "mdi-eye-off" : "mdi-eye";
    },
  },
};
</script>
